// Configuración de métodos de pago habilitados/deshabilitados
const paymentMethods = {
  visa: true,
  mastercard: false,
  webpay: true,
  getnet: false,
  khipu: false,
};

export default paymentMethods;
